import { render, staticRenderFns } from "./VTabs.vue?vue&type=template&id=414f187f&scoped=true"
import script from "./VTabs.vue?vue&type=script&lang=js"
export * from "./VTabs.vue?vue&type=script&lang=js"
import style0 from "./VTabs.vue?vue&type=style&index=0&id=414f187f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414f187f",
  null
  
)

export default component.exports